import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './i18n';
import App from './App';
import { setAxiosResponseInterceptors } from './redux';
import store from './redux/store';

import './styles/index.scss';

/* eslint-disable @typescript-eslint/no-non-null-assertion */
const container = document.getElementById('root');
const root = createRoot(container!);
/* eslint-enable @typescript-eslint/no-non-null-assertion */

setAxiosResponseInterceptors();

root.render(
	<Provider store={ store }>
		<BrowserRouter>
			<React.Suspense fallback="Loading ...">
				<App />
			</React.Suspense>
		</BrowserRouter>
	</Provider>
);
